import type { PartnerAddressV2, PartnerContact, PartnerOrigin, PartnerTenant } from '@shipium-corp/shipium-ts-types';
import type { Schedule } from '../../services/FP_FulfillmentContextService/types';
import { hydrateOrigin } from './hydrateOrigin';

export interface HydrateOriginsParams {
  origins: PartnerOrigin[];
  addressList: PartnerAddressV2[];
  scheduleList: Schedule[];
  contactList: PartnerContact[];
  tenantList: PartnerTenant[];
}

export const hydrateOrigins = ({
  origins,
  addressList,
  scheduleList,
  contactList,
  tenantList,
}: HydrateOriginsParams) => {
  const addresses: Record<string, PartnerAddressV2> = {};
  for (const curr of addressList) {
    addresses[curr.addressId!] = curr;
  }
  const schedules: Record<string, Schedule> = {};
  for (const curr of scheduleList) {
    schedules[curr.scheduleId] = curr;
  }
  const contacts: Record<string, PartnerContact> = {};
  for (const curr of contactList) {
    contacts[curr.contactId!] = curr;
  }
  return origins.map((origin) => hydrateOrigin({ addresses, schedules, contacts, tenantList, origin }));
};
